import * as types from 'actions/actionTypes';
import * as services from 'services/apis/crashboxx/crashboxxServices';
import {beginAjaxCall, ajaxCallError} from './ajaxStatusActions';
import * as miscServices from 'services/miscServices';


export function getPdofRequest(){
    return {type: types.GET_PDOF_REQUEST}
}

export function getPdofSuccess(data){
    return {type: types.GET_PDOF_SUCCESS, data}
}

export function getPdofError(error){
    return {type: types.GET_PDOF_ERROR, error}
}

/**
 * get pdof binaries
 * @param {angle} angle
 */
export const getPdof = (angle) => dispatch => {
    dispatch(getPdofRequest());
    dispatch(beginAjaxCall());

    services.getPdofImage(angle)

        .then(response => {
            dispatch(getPdofSuccess(response.data));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(getPdofError(error));
    });
}

export function getPredictiveImageRequest(){
    return {type: types.GET_PREDICTIVEIMAGE_REQUEST}
}

export function getPredictiveImageSuccess(data){
    return {type: types.GET_PREDICTIVEIMAGE_SUCCESS, data}
}

export function getPredictiveImageError(error){
    return {type: types.GET_PREDICTIVEIMAGE_ERROR, error}
}

/**
 * get predictive image binaries
 */
export const getPredictiveImage = (pdof, severityCode, vehicleClass) => dispatch => {
    dispatch(getPredictiveImageRequest());
    dispatch(beginAjaxCall());

    services.getPredictiveImage(pdof, severityCode, vehicleClass)

        .then(response => {
            dispatch(getPredictiveImageSuccess(response.data));
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(getPredictiveImageError(error));
    });
}

export function downloadSingleExcelRequest(){
    return {type: types.DOWNLOAD_SINGLEEXCEL_REQUEST}
}

export function downloadSingleExcelSuccess(){
    return {type: types.DOWNLOAD_SINGLEEXCEL_SUCCESS}
}

export function downloadSingleExcelError(error){
    return {type: types.DOWNLOAD_SINGLEEXCEL_ERROR, error}
}

/**
 * download single excel file
 */
export const downloadSingleExcel = (id, isIcnPlus, isDent) => dispatch => {
    dispatch(downloadSingleExcelRequest());
    dispatch(beginAjaxCall());

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.ExportSingleToExcel(id, pageType)
        .then(response => {
            dispatch(downloadSingleExcelSuccess());
            var fileName = "Instant Crash Alert.xls";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction.xls";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage.xls";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadSingleExcelError(error));
    });
}

export function downloadSinglePdfRequest(){
    return {type: types.DOWNLOAD_SINGLEPDF_REQUEST}
}

export function downloadSinglePdfSuccess(){
    return {type: types.DOWNLOAD_SINGLEPDF_SUCCESS}
}

export function downloadSinglePdfError(error){
    return {type: types.DOWNLOAD_SINGLEPDF_ERROR, error}
}

/**
 * download single pdf file
 */
export const downloadSinglePdf = (id, isIcnPlus, isDent) => dispatch => {
    dispatch(downloadSinglePdfRequest());
    dispatch(beginAjaxCall());

    const params = new URLSearchParams(window.location.search || "");
    const version = params.get("v") || "1";

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.ExportSingleToPdf(id, pageType, version)
        .then(response => {
            dispatch(downloadSinglePdfSuccess());
            var fileName = "Instant Crash Alert.pdf";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction.pdf";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage.pdf";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadSinglePdfError(error));
    });
}

export function downloadSingleCsvRequest(){
    return {type: types.DOWNLOAD_SINGLECSV_REQUEST}
}

export function downloadSingleCsvSuccess(){
    return {type: types.DOWNLOAD_SINGLECSV_SUCCESS}
}

export function downloadSingleCsvError(error){
    return {type: types.DOWNLOAD_SINGLECSV_ERROR, error}
}

/**
 * download single csv file
 */
export const downloadSingleCsv = (id, isIcnPlus, isDent) => dispatch => {
    dispatch(downloadSingleCsvRequest());
    dispatch(beginAjaxCall());

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.ExportSingleToCsv(id, pageType)
        .then(response => {
            dispatch(downloadSingleCsvSuccess());
            var fileName = "Instant Crash Alert.csv";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction.csv";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage.csv";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadSingleCsvError(error));
    });
}




export function downloadListExcelRequest(){
    return {type: types.DOWNLOAD_LISTEXCEL_REQUEST}
}

export function downloadListExcelSuccess(){
    return {type: types.DOWNLOAD_LISTEXCEL_SUCCESS}
}

export function downloadListExcelError(error){
    return {type: types.DOWNLOAD_LISTEXCEL_ERROR, error}
}

/**
 * download excel files
 */
export const downloadListExcel = (list, isIcnPlus, isDent) => dispatch => {
    dispatch(downloadListExcelRequest());
    dispatch(beginAjaxCall());

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.exportListToExcel(list, pageType)
        .then(response => {
            dispatch(downloadListExcelSuccess());
            var fileName = "Instant Crash Alert list.xls";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction list.xls";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage list.xls";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadListExcelError(error));
    });
}



export function downloadAllListExcelRequest(){
    return {type: types.DOWNLOAD_ALLLISTEXCEL_REQUEST}
}

export function downloadAllListExcelSuccess(){
    return {type: types.DOWNLOAD_ALLLISTEXCEL_SUCCESS}
}

export function downloadAllListExcelError(error){
    return {type: types.DOWNLOAD_ALLLISTEXCEL_ERROR, error}
}

/**
 * download excel files
 */
export const downloadAllListExcel = (data, isIcnPlus, isDent) => dispatch => {
    dispatch(downloadAllListExcelRequest());
    dispatch(beginAjaxCall());

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.exportAllListToExcel(data.icnId, data.selectedDeviceIdType, data.deviceFilterValue, data.vin, data.dateFrom, data.dateTo, data.selectedSeverityValues,
        data.device, data.vehicle, data.selectedAccount, data.selectedClassificationValue, data.includeSubAccount, pageType)
        .then(response => {
            dispatch(downloadAllListExcelSuccess());
            var fileName = "Instant Crash Alert list.xls";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction list.xls";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage list.xls";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadAllListExcelError(error));
    });
}



export function downloadListPdfRequest(){
    return {type: types.DOWNLOAD_LISTPDF_REQUEST}
}

export function downloadListPdfSuccess(){
    return {type: types.DOWNLOAD_LISTPDF_SUCCESS}
}

export function downloadListPdfError(error){
    return {type: types.DOWNLOAD_LISTPDF_ERROR, error}
}

/**
 * download pdf files in zip
 */
export const downloadListPdf = (list, isIcnPlus, isDent) => dispatch => {

    dispatch(downloadListPdfRequest());
    dispatch(beginAjaxCall());

    const params = new URLSearchParams(window.location.search || "");
    const version = params.get("v") || "1";

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.exportListToPdf(list, pageType, version)
        .then(response => {
            dispatch(downloadListPdfSuccess());
            var fileName = "Instant Crash Alert list.zip";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction list.zip";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage list.zip";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadListPdfError(error));
    });
}



export function downloadAllListPdfRequest(){
    return {type: types.DOWNLOAD_ALLLISTPDF_REQUEST}
}

export function downloadAllListPdfSuccess(){
    return {type: types.DOWNLOAD_ALLLISTPDF_SUCCESS}
}

export function downloadAllListPdfError(error){
    return {type: types.DOWNLOAD_ALLLISTPDF_ERROR, error}
}

/**
 * download pdf files in zip
 */
export const downloadAllListPdf = (data, isIcnPlus, isDent) => dispatch => {

    dispatch(downloadAllListPdfRequest());
    dispatch(beginAjaxCall());

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.exportAllListToPdf(data.icnId, data.selectedDeviceIdType, data.deviceFilterValue, data.vin, data.dateFrom, data.dateTo, data.selectedSeverityValues,
        data.device, data.vehicle, data.selectedAccount, data.selectedClassificationValue, data.includeSubAccount, pageType)
        .then(response => {
            dispatch(downloadAllListPdfSuccess());
            var fileName = "Instant Crash Alert list.zip";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction list.zip";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage list.zip";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadAllListPdfError(error));
    });
}





export function downloadListCsvRequest(){
    return {type: types.DOWNLOAD_LISTCSV_REQUEST}
}

export function downloadListCsvSuccess(){
    return {type: types.DOWNLOAD_LISTCSV_SUCCESS}
}

export function downloadListCsvError(error){
    return {type: types.DOWNLOAD_LISTCSV_ERROR, error}
}

/**
 * download csv files
 */
export const downloadListCsv = (list, isIcnPlus, isDent) => dispatch => {

    dispatch(downloadListCsvRequest());
    dispatch(beginAjaxCall());

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.exportListToCsv(list, pageType)
        .then(response => {
            dispatch(downloadListCsvSuccess());
            var fileName = "Instant Crash Alert list.csv";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction list.csv";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage list.csv";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadListCsvError(error));
    });
}

export function downloadAllListCsvRequest(){
    return {type: types.DOWNLOAD_ALLLISTCSV_REQUEST}
}

export function downloadAllListCsvSuccess(){
    return {type: types.DOWNLOAD_ALLLISTCSV_SUCCESS}
}

export function downloadAllListCsvError(error){
    return {type: types.DOWNLOAD_ALLLISTCSV_ERROR, error}
}

/**
 * download csv files
 */
export const downloadAllListCsv = (data, isIcnPlus, isDent) => dispatch => {

    dispatch(downloadAllListCsvRequest());
    dispatch(beginAjaxCall());

    var pageType = 1;
    if(isIcnPlus)
    {
        pageType = 2;
    }
    if(isDent)
    {
        pageType = 3;
    }

    services.exportAllListToCsv(data.icnId, data.selectedDeviceIdType, data.deviceFilterValue, data.vin, data.dateFrom, data.dateTo, data.selectedSeverityValues,
        data.device, data.vehicle, data.selectedAccount, data.selectedClassificationValue, data.includeSubAccount, pageType)
        .then(response => {
            dispatch(downloadAllListCsvSuccess());
            var fileName = "Instant Crash Alert list.csv";
            if(isIcnPlus)
            {
                fileName = "Accident Reconstruction list.csv";
            }
            if(isDent)
            {
                fileName = "Predictive Physical Damage list.csv";
            }

            var file = miscServices.base64toBlob(response.data.binaries, 'application/octet-stream', fileName);
            // IE Fix - IE10+ : (has Blob, but not a[download] or URL)
            if (navigator.msSaveBlob) {
                return navigator.msSaveBlob(file, fileName);
            }
            else {
                // Use a "trick" to download attachment on local browser
                var url = window.URL || window.webkitURL;
                var fileURL = url.createObjectURL(file);
                var a = document.createElement("a");
                document.body.appendChild(a);
                a.href = fileURL;
                a.download = fileName;
                a.click();
                url.revokeObjectURL(fileURL);
                a.remove();
                return null;
            }
        })
        .catch(error => {
            dispatch(ajaxCallError(error));
            dispatch(downloadAllListCsvError(error));
    });
}


// WEBPACK FOOTER //
// ./src/actions/crashboxxServicesActions.js